import { render, staticRenderFns } from "./provinceCityAreaData.vue?vue&type=template&id=7c1d0f14&scoped=true&"
import script from "./provinceCityAreaData.vue?vue&type=script&lang=js&"
export * from "./provinceCityAreaData.vue?vue&type=script&lang=js&"
import style0 from "./provinceCityAreaData.vue?vue&type=style&index=0&id=7c1d0f14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d0f14",
  null
  
)

export default component.exports